/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_ConditionsInputs */

const en_clients_payment_terms_conditions = /** @type {(inputs: Clients_Payment_Terms_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment terms`)
};

const pt_br2_clients_payment_terms_conditions = /** @type {(inputs: Clients_Payment_Terms_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condições de pagamento`)
};

/**
* | output |
* | --- |
* | "Payment terms" |
*
* @param {Clients_Payment_Terms_ConditionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_conditions = /** @type {((inputs?: Clients_Payment_Terms_ConditionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_ConditionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_conditions(inputs)
	return pt_br2_clients_payment_terms_conditions(inputs)
});